export default function Footer() {
  return (
    <footer className='awards-footer'>
      <div className='inner'>
        <i className='logo'/>
        <div className='last'>
          <p className='text'>Copyright  2013-2024 Tencent Cloud. All Rights Reserved</p>
          <div className='link-group'>
            <a href="/awards2024/privacyPolicy" target="_blank" className="link" rel="noreferrer">Privacy Policy</a>
            {/* <a href="#" target="_blank" className="link" rel="noreferrer">Legal</a> */}
            <a href="/awards2024/cookiePolicy" target="_blank" className="link" rel="noreferrer">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
